module.exports = __webpack_public_path__ + "img/airwaysminus.cf6aa8ca.svg";